import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Personas cansadas de que el sueldo no llegue a fin de mes.', 'Estudiantes que quieren independencia económica real.', 'Empleados que buscan una salida de emergencia de su trabajo actual.', 'Cualquier persona con una computadora y 2 horas libres al día.'];
const notForWho = ['Quienes buscan "dinero mágico" sin hacer absolutamente nada.', 'Personas que no están dispuestas a aprender a usar herramientas básicas de IA.', 'Gente que se queja de la situación pero no toma acción cuando tiene el mapa en la mano.'];
export function AudienceSection() {
  return <section className="py-20 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2">
        {/* Who this is for */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0a0f1a] border border-emerald-900/50 rounded-3xl p-8 md:p-10" data-id="element-3">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-4">
            <span className="bg-emerald-500/20 p-2 rounded-lg" data-id="element-5">
              <Check className="w-6 h-6 text-emerald-400" data-id="element-6" />
            </span>
            Esto ES para vos si...
          </h3>
          <ul className="space-y-6" data-id="element-7">
            {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-8">
                <Check className="w-6 h-6 text-emerald-500 shrink-0 mt-0.5" data-id="element-9" />
                <span className="text-gray-300 leading-relaxed" data-id="element-10">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Who this is NOT for */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0a0f1a] border border-red-900/30 rounded-3xl p-8 md:p-10 opacity-80" data-id="element-11">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-12">
            <span className="bg-red-500/10 p-2 rounded-lg" data-id="element-13">
              <X className="w-6 h-6 text-red-400" data-id="element-14" />
            </span>
            Esto NO es para vos si...
          </h3>
          <ul className="space-y-6" data-id="element-15">
            {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-16">
                <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-17" />
                <span className="text-gray-400 leading-relaxed" data-id="element-18">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}